import styled from 'styled-components';
import ReactDatePicker from 'react-datepicker';

export const Container = styled.div`
  display: flex;
  min-height: 48px;
  min-width: 300px;
  margin: 0;
  padding: 0;
  align-items: center;
  justify-content: center;
  caret-color: transparent;
  > button {
    border: 0;
    background: none;
    display: flex;
    /* height: 48px; */

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  svg {
    color: ${props => props.theme.fontColor};
  }

  h4 {
    margin: 0;
    padding: 0;
    line-height: 48px;
    text-align-last: center;
  }
`;

export const StyledDatePicker = styled(ReactDatePicker)`
  z-index: 3;
  position: relative;
  color: ${props => props.theme.fontColor};
  background: none;
  border: none;
  align-self: center;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
